import { Link, TagProperties, Text, TextProps } from '@nimbus-ds/components';
import { differenceInDays } from 'date-fns';
import { useTranslationCommon } from 'commons/hooks';
import { dateFormat, Format } from 'commons/utils/date';
import goToAdmin from 'commons/utils/gotToAdmin/goToAdmin';
import useGetPlanDebt from 'domains/Auth/hooks/useGetPlanDebt/useGetPlanDebt';
import { trackingBillingPostUpsellAdbarClick } from 'domains/Billing/tracking';
import { AdBar } from './AdBar';

export function PlanDebtAdBar() {
  const t = useTranslationCommon('topAdBar.planDebt');
  const goToCheckout = goToAdmin('account/checkout/start/');
  const { planDebtData } = useGetPlanDebt();

  const handleClick = () => {
    trackingBillingPostUpsellAdbarClick('plan-debt-adbar');
    goToCheckout();
  };

  if (
    !planDebtData ||
    !planDebtData.paidUntilDate ||
    !planDebtData.adminDownDate ||
    !planDebtData.storeDownDate
  )
    return null;

  const today = new Date();
  const daysUntilAdminDown = differenceInDays(
    new Date(planDebtData.adminDownDate),
    today,
  );

  const adminDownDateIsNear = daysUntilAdminDown < 5 && daysUntilAdminDown > 0;
  const adminDownDateIsFar =
    new Date(planDebtData.paidUntilDate) <= today && daysUntilAdminDown >= 5;
  const adminDownDateIsExpired = daysUntilAdminDown <= 0;

  if (!adminDownDateIsNear && !adminDownDateIsFar && !adminDownDateIsExpired) {
    return null;
  }

  const getAdBarProps = (): {
    appearance: TagProperties['appearance'];
    color: TextProps['color'];
    messageText: string;
  } => {
    if (adminDownDateIsNear) {
      return {
        appearance: 'danger',
        color: 'danger-textLow',
        messageText: t('dangerText', { count: daysUntilAdminDown }),
      };
    } else if (adminDownDateIsFar) {
      return {
        appearance: 'warning',
        color: 'warning-textLow',
        messageText: t('warningText', {
          date: dateFormat(
            new Date(planDebtData.adminDownDate).toISOString(),
            Format.DD_MM,
          ),
        }),
      };
    } else {
      return {
        appearance: 'danger',
        color: 'danger-textLow',
        messageText: t('dangerText', {
          count: differenceInDays(new Date(planDebtData.storeDownDate), today),
        }),
      };
    }
  };

  const adBarProps = getAdBarProps();

  return (
    <AdBar appearence={adBarProps.appearance}>
      <Text fontWeight="bold" color={adBarProps.color}>
        {adBarProps.messageText}
        <Link onClick={handleClick} appearance="primary" textDecoration="none">
          {t('link')}
        </Link>
      </Text>
    </AdBar>
  );
}
